import { useMemo } from "react";

import { SVGGraphColumnNavProps } from "./SVGGraphColumnNavTypes";
import { getNavAvailability } from "./SVGGraphColumnNavUtils";

export const useSVGGraphColumnNavAvailability = ({
  dataType,
  allStatsData,
  currentYear,
  currentMonth,
  counter,
  deltaCounter,
}: SVGGraphColumnNavProps) =>
  useMemo(
    () =>
      getNavAvailability({
        dataType,
        allStatsData,
        currentYear,
        currentMonth,
        counter,
        deltaCounter,
      }),
    [allStatsData, counter, currentMonth, currentYear, dataType, deltaCounter],
  );
